import React, { useState } from "react";
import { LanguageSelector } from "./LanguageSelector/LanguageSelector";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { getMode } from "../../../utils/getMode";

export const HeaderButtons = () => {
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const [mode] = useState(getMode());

  if (mode === "embedded") {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: isScreenXs ? "14px" : "8px",
        right: "0.8rem",
        display: "flex",
        alignItems: "center",
        gridGap: "0.5rem",
      }}
    >
      <LanguageSelector />
    </div>
  );
};
